import type { FormEventHandler, ReactNode } from "react"

import type { SX } from "../../theme"
import styles from "./Form.module.css"

export interface FormProps {
  id?: string
  children?: ReactNode
  sx?: SX
  onSubmit?: FormEventHandler<HTMLFormElement>
}

export function Form(props: FormProps) {
  const { id, children, sx, onSubmit } = props

  return (
    <form
      id={id}
      className={styles.root}
      style={sx}
      onSubmit={(evt) => {
        evt.preventDefault()
        onSubmit?.(evt)
      }}
    >
      {children}
    </form>
  )
}
